/**
 * Custom hook for fetching organization-level OKR statistics
 * Used by Dashboard to display org-wide stats in the top cards
 */

import { useQuery } from '@tanstack/react-query';
import { okrService } from '../services';

export interface OrgStats {
  totalActiveOKRs: number;
  avgProgress: number;
  totalKeyResults: number;
  checkInsDue: number;
  closedOKRs: number;
}

export interface OrgStatsFilters {
  startDate?: string;
  endDate?: string;
}

/**
 * Hook to fetch organization-level OKR stats
 * Optionally filtered by date range
 */
export const useOrgStats = (filters?: OrgStatsFilters) => {
  return useQuery<OrgStats>({
    queryKey: ['org-stats', filters?.startDate, filters?.endDate],
    queryFn: () => okrService.getOrganizationStats(filters),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
